import React, { useState } from 'react';

import EnvelopeUrl from '@pkg/assets/images/Envelope.png';
import { useAppSelector, useMagicLink } from '@pkg/hooks';

import { useMagicLink as useMagicLinkStore } from '@app/store/zustand';

import { Typography } from '../../DesignSystem';
import { DepButton } from '../../deprecated';
import {
    Container,
    EmojiImage,
    ErrorMessage,
    FormGroup,
    FormRow,
    NotificationMessage,
    PrimaryCopySection,
    Section,
} from '../Web3Auth.style';
import { useWeb3AuthContext } from '../context';

export function EmailActivation() {
    const { authEmail } = useWeb3AuthContext();
    const accountEmail = useAppSelector((rootState) => rootState.user.userAccount?.user.email);
    const { sendMagicLink } = useMagicLink();
    const { setMagicLinkEmailAddress } = useMagicLinkStore();

    const [loading, setLoading] = useState(false);
    const [confirmationSent, setConfirmationSent] = useState(false);
    const [hasConfirmationError, setHasConfirmationError] = useState(false);

    const email = authEmail || accountEmail;

    async function handleSendConfirmation() {
        setLoading(true);

        try {
            if (!email) {
                throw new Error('Error generating magic link');
            }

            const magicLinkResponse = await sendMagicLink({ email });

            if (magicLinkResponse.ok && magicLinkResponse.value) {
                setMagicLinkEmailAddress(email);
                setConfirmationSent(true);
            }
            setLoading(false);
        } catch (_error) {
            setLoading(false);
            setHasConfirmationError(true);
        }
    }

    return (
        <Container>
            <Section className="hide-on-tablet">
                <EmojiImage src={EnvelopeUrl} />
            </Section>

            <PrimaryCopySection>
                <Typography type="headline" size={40}>
                    Check your inbox for an email from us!
                </Typography>
                <Typography type="paragraph" size={18} faded={true}>
                    We sent an email to <em>{email}</em>. Confirm your email to finish creating your account.
                </Typography>
            </PrimaryCopySection>

            <Section>
                <FormGroup>
                    <FormRow>
                        <DepButton
                            variant="glow"
                            disabled={confirmationSent}
                            onClick={handleSendConfirmation}
                            loading={loading}
                        >
                            Resend email
                        </DepButton>
                    </FormRow>
                    <FormRow>
                        <NotificationMessage>{confirmationSent && 'Email sent!'}</NotificationMessage>
                        <ErrorMessage>
                            {hasConfirmationError && 'Sorry, there was an error sending the email'}
                        </ErrorMessage>
                    </FormRow>
                </FormGroup>
            </Section>
        </Container>
    );
}
